import { Col, Form, Image, Row } from "react-bootstrap";
import "../../assets/scss/components/sections/authentication/authentication.scss";

import logo from "../../assets/images/logo.svg";
import img1 from "../../assets/images/authentication/signup.svg";
import google from "../../assets/images/authentication/google.svg";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

import { useState } from "react";
import loading from "../../assets/images/loading.svg";
import {
  getBaseApiURL,
  console_log,
  showToast,
} from "../../utils/commonHelper";
import axios from "axios";
import { setCookie, setLocalStorage } from "../../utils/userHelper";
import BackBtn from "../../components/templates/back";
import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import { checkExistingFileToDownload } from "./helper";

const Signup = () => {
  const [emailAddress, setEmailAddress] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [isDisabled, setIsDisabled] = useState(false);
  const [signupStep, setSignupStep] = useState(1);
  const [verificationCode, setVerificationCode] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);
  const [isDisableGoogleLogin, setIsDisableGoogleLogin] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const jobURL = urlParams.get("jobURL"); // Gets the value of "abc"

    if (jobURL !== null && jobURL !== undefined && jobURL !== "") {
      setLocalStorage("job_url", jobURL);
    }
  }, []);

  const handleInputChange = (index, value) => {
    // Allow only single numeric or alphabetical character
    if (value.length <= 1 && /^[a-zA-Z0-9]*$/.test(value)) {
      const updatedCode = [...verificationCode];
      updatedCode[index] = value;
      setVerificationCode(updatedCode);

      // Automatically move to the next input field if value is valid
      if (value && index < verificationCode.length - 1) {
        document.getElementById(`code-input-${index + 1}`).focus();
      }
    }
  };
  const loginCalling = async (data) => {
    let url = getBaseApiURL() + `/auth/login`;
    await axios
      .post(url, data, {
        headers: {
          "Content-Type": "application/json", // Set content type
        },
      })
      .then((response) => {
        setIsDisabled(false);
        let data = response.data;
        setCookie("access_token", data.access_token);
        setCookie("id_token", data.id_token);
        setCookie("refresh_token", data.refresh_token);
        navigate("/");
      })
      .catch((error) => {
        setIsDisabled(false);
        showToast(error, "error");
      });
  };
  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && index > 0 && !verificationCode[index]) {
      // Move to the previous field on Backspace if current field is empty
      document.getElementById(`code-input-${index - 1}`).focus();
    }
  };
  const handlePaste = (index, e) => {
    e.preventDefault(); // Prevent default paste behavior
    const pastedData = e.clipboardData.getData("text");
    const updatedCode = [...verificationCode];

    // Distribute the pasted content across the input fields
    for (let i = 0; i < pastedData.length && i < verificationCode.length; i++) {
      updatedCode[i] = pastedData[i];
    }

    setVerificationCode(updatedCode);

    // Focus the next input field if all fields are filled
    if (pastedData.length >= verificationCode.length) {
      document
        .getElementById(`code-input-${verificationCode.length - 1}`)
        .focus();
    }
  };
  const step = 2;

  const sendRequest = (type = "email", data) => {
    if (type == "email") setIsDisabled(true);

    let url = getBaseApiURL() + `/users/register`;
    console_log("data", data, url);

    if (type == "google") url = getBaseApiURL() + `/auth/google-auth`;

    axios
      .post(url, data, {
        headers: {
          "Content-Type": "application/json", // Set content type
        },
      })
      .then((response) => {
        if (type == "email") setIsDisabled(false);
        let data = response.data;
        if (type != "google") {
          console_log("data...", data);
          setSignupStep(2);
        } else {
          setIsDisabled(false);
          let data = response.data;
          console_log("data...", data);
          setCookie("access_token", data.access_token);
          setCookie("id_token", data.id_token);
          setCookie("refresh_token", data.refresh_token);
          checkExistingFileToDownload(navigate);
        }
      })
      .catch((error) => {
        if (type == "email") setIsDisabled(false);
        showToast(error, "error");
      });
  };
  const clickedConfirmationCodeButton = async () => {
    let confirmation_code = verificationCode.join("");
    setIsDisabled(true);
    console_log("encodeURI", encodeURIComponent(emailAddress));
    let url =
      getBaseApiURL() +
      `/auth/confirm-email?email=${encodeURIComponent(
        emailAddress
      )}&confirmation_code=${confirmation_code}`;
    console_log("url", url);

    await axios
      .post(
        url,
        {},
        {
          headers: {
            "Content-Type": "application/json", // Set content type
          },
        }
      )
      .then((response) => {
        let data = {
          email: emailAddress,
          password: password,
        };
        loginCalling(data);
      })
      .catch((error) => {
        setIsDisabled(false);
        showToast(error, "error");
      });
  };
  const clickedResendCodeButton = async (event) => {
    event.preventDefault();
    setIsDisabled(true);
    let url =
      getBaseApiURL() +
      `/auth/resend-confirmation?email=${encodeURIComponent(emailAddress)}`;
    await axios
      .post(
        url,
        {},
        {
          headers: {
            "Content-Type": "application/json", // Set content type
          },
        }
      )
      .then((response) => {
        showToast("check email");
        setIsDisabled(false);
      })
      .catch((error) => {
        setIsDisabled(false);
        showToast(error, "error");
      });
  };
  const clickedRegisterButton = () => {
    if (emailAddress == "" || password == "") {
      console_log("error");
      showToast("Email Or Password Field is required", "error");
    } else {
      setIsDisabled(true);
      sendRequest("email", {
        email: emailAddress,
        password: password,
      });
    }
  };
  const responseMessage = (response) => {
    setIsDisableGoogleLogin(true);
    console_log("default", response);
    sendRequest("google", {
      token: response.access_token,
    });
  };
  const errorMessage = (error) => {
    setIsDisableGoogleLogin(false);
    showToast(error);
  };

  const GoogleLoginFunc = useGoogleLogin({
    onSuccess: responseMessage,
    onError: errorMessage,
    scope: "", // Ensure "openid" is included to receive ID token
  });

  const clickedGoogleLoginButton = useGoogleLogin({
    onSuccess: responseMessage,
    onError: errorMessage,
    scope: "", // Ensure "openid" is included to receive ID token
  });

  return signupStep === 1 ? (
    <div className="authentication">
      <Row className="align-items-center signup-col-parent h-100">
        <Col lg={6} className="left-side">
          <div className="authentication-content">
            <div className="authentication-content-box">
              <div className="logo">
                <Image src={logo} />
              </div>
              <div className="img-1">
                <Image src={img1} className="img-fluid" />
              </div>
              <h2 className="heading-4 mb-1">AI Resume Builder</h2>
              <p className="paragraph-main-regular font-size-14">
                Build job-winning resumes and cover letters effortlessly with
                ATS-friendly formatting, personalized cover letters, and
                tailored resumes for every job—saving you time and increasing
                your chances of landing more interviews.
              </p>
            </div>
          </div>
        </Col>
        <Col lg={6} className="right-side">
          <div className="d-flex justify-content-center">
            <div className="form">
              <Image src={logo} className="logo" />
              <h4 className="heading-4">Signup to Get Started</h4>
              <div>
                <Form>
                  <Form.Group className="mb-3">
                    <Form.Control
                      type="email"
                      placeholder="Email Address"
                      value={emailAddress}
                      onInput={(e) => setEmailAddress(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Control
                      type="password"
                      placeholder="Password"
                      value={password}
                      onInput={(e) => setPassword(e.target.value)}
                    />
                  </Form.Group>
                  <button
                    type="button"
                    className="btn-primary z-2 position-relative btn btn-primary"
                    onClick={clickedRegisterButton}
                    disabled={isDisabled}
                  >
                    <span>Continue with Email</span>
                    <img className="loading-icon" src={loading} alt="" />
                  </button>
                </Form>
              </div>
              <p className="paragraph-main-regular text-center already-have-account">
                Already Have Account?
                <a href="/login" className="link">
                  Login
                </a>
              </p>
              <p className="or">OR</p>
              {/*<GoogleLogin onSuccess={responseMessage} onError={errorMessage} />*/}

              <button
                type="button"
                className="z-2 position-relative btn btn-outline google-button"
                onClick={clickedGoogleLoginButton}
                disabled={isDisableGoogleLogin}
              >
                <img className="" src={google} alt="" />
                <span className="ml-1"> Continue with Google</span>
                <img
                  src={loading}
                  alt=""
                  style={{
                    display: !isDisableGoogleLogin && "none",
                    width: "30px",
                    color: "black",
                    animation: "spin 0.5s linear infinite",
                  }}
                />
              </button>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  ) : (
    <div className="signup-2-section authentication">
      <BackBtn backButtonPress={() => setSignupStep(1)} />
      <div className="form">
        <h4 className="heading-4">We Need Some More Information</h4>
        <div className="d-flex align-items-center justify-content-between">
          {verificationCode.map((value, index) => (
            <Form.Group
              key={index}
              className="verification-code-each-input input-field no-spinner"
            >
              <Form.Control
                type="text"
                id={`code-input-${index}`}
                value={value}
                onChange={(e) => handleInputChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                onPaste={(e) => handlePaste(index, e)}
                inputMode="text" // Use text input mode
                maxLength={1} // Restrict to one character
                className="text-center" // Center align the input content
              />
            </Form.Group>
          ))}
        </div>
        <button
          type="button"
          className="btn-primary z-2 position-relative btn btn-primary"
          onClick={clickedConfirmationCodeButton}
          disabled={isDisabled}
        >
          <span>Confirm Verification Code</span>
          <img className="loading-icon" src={loading} alt="" />
        </button>
        <p className="resend-code paragraph-small-regular mb-3 resend-button">
          <a onClick={clickedResendCodeButton}>Resend Code</a>
        </p>
      </div>
    </div>
  );
};

export default Signup;
